'use client';

import { Flex, Button, createListCollection } from '@skin-seoul/design-system';
import { useState, useMemo } from 'react';
import ProductFinderSelect from './ProductFinderSelect';
import { useSkinType } from '@skin-seoul/service';
import { useSkinConcern } from '@skin-seoul/service';
import { productFinderGenerateUrl, createTermIdExtractor } from '@skin-seoul/service';
import { useProductService } from '@skin-seoul/service';
import { convertToPascalCase } from '@skin-seoul/utils';
import { useSafeRouter } from '@/hooks/useSafeRouter';
const ProductFinderContent = () => {
  const router = useSafeRouter();
  const skinTypeOptions = useSkinType();
  const skinConcernOptions = useSkinConcern();
  const {
    useGetSuspenseProductTaxonomy,
    useGetSuspenseAllCategoryTaxonomy
  } = useProductService();
  const {
    data: taxonomy
  } = useGetSuspenseProductTaxonomy();
  const {
    data: allCategories
  } = useGetSuspenseAllCategoryTaxonomy();
  const parentCategories = useMemo(() => {
    if (!allCategories) {
      return [];
    }
    return allCategories.filter(category => !category.parentTermId);
  }, [allCategories]);
  const [productType, setProductType] = useState<string[]>(['all']);
  const [skinType, setSkinType] = useState<string[]>(['all']);
  const [skinConcern, setSkinConcern] = useState<string[]>(['all']);
  const productCollection = useMemo(() => createListCollection({
    items: [{
      label: 'All products',
      value: 'all'
    }, ...parentCategories.map(category => ({
      label: category.name,
      value: category.slug
    }))]
  }), [parentCategories]);
  const skinTypeCollection = useMemo(() => createListCollection({
    items: skinTypeOptions
  }), [skinTypeOptions]);
  const concernCollection = useMemo(() => createListCollection({
    items: skinConcernOptions.map(option => ({
      label: convertToPascalCase(option.label),
      value: option.value
    }))
  }), [skinConcernOptions]);
  const getSkinTypeTermId = useMemo(() => createTermIdExtractor(taxonomy?.skinType), [taxonomy]);
  const getSkinConcernTermId = useMemo(() => createTermIdExtractor(taxonomy?.skinConcern), [taxonomy]);
  const handleShowSolutions = () => {
    const url = productFinderGenerateUrl({
      productType: productType[0],
      skinType: skinType[0],
      skinConcern: skinConcern[0],
      getSkinTypeTermId,
      getSkinConcernTermId
    });
    router.push(url);
  };
  return <>
      <Flex direction={{
      base: 'column',
      desktop: 'row'
    }} gap={{
      base: 12,
      desktop: 16
    }} padding={4} width="100%" data-sentry-element="Flex" data-sentry-source-file="ProductFinderContent.tsx">
        <ProductFinderSelect label="I'm looking for" collection={productCollection} value={productType} onValueChange={details => setProductType(details.value)} data-sentry-element="ProductFinderSelect" data-sentry-source-file="ProductFinderContent.tsx" />

        <ProductFinderSelect label="My skin type is" collection={skinTypeCollection} value={skinType} onValueChange={details => setSkinType(details.value)} data-sentry-element="ProductFinderSelect" data-sentry-source-file="ProductFinderContent.tsx" />

        <ProductFinderSelect label="My skin concern is" collection={concernCollection} value={skinConcern} onValueChange={details => setSkinConcern(details.value)} data-sentry-element="ProductFinderSelect" data-sentry-source-file="ProductFinderContent.tsx" />
      </Flex>

      <Button backgroundColor="transparent" border="1px solid" borderColor="generic.0" borderRadius="8px" color="generic.0" textStyle="paragraph.small" fontWeight="regular" height="48px" width={{
      base: 'full',
      tablet: '332px'
    }} _hover={{
      backgroundColor: 'primary.500'
    }} _active={{
      backgroundColor: 'primary.300',
      borderColor: 'primary.300'
    }} onClick={handleShowSolutions} alignSelf="center" data-sentry-element="Button" data-sentry-source-file="ProductFinderContent.tsx">
        Show my solutions
      </Button>
    </>;
};
export default ProductFinderContent;